<template>
  <div class='prize-content'>
    <group-wise>
      <template v-slot:group><img src="../../assets/img/reward/自由平面.png" alt="" /></template>
      <template v-slot:rewards1>
        <div><img src="../../assets/img/reward/1.1.png" alt=""></div>
      </template>
      <template v-slot:works1><a
          href="https://designvue.benq.com.cn/2021/freeThemeWorks/imageWorkDetail?id=1398&type=2&views=7"><img
            src="../../assets/img/reward/1-1.png" alt=""></a></template>
      <template v-slot:works-name1><span>《梦回雅宋插画长卷》 &nbsp;&nbsp;陈嘉林</span></template>
      <template v-slot:rewards2>
        <div><img src="../../assets/img/reward/1.2.png" alt=""></div>
      </template>
      <template v-slot:works2>
        <div><a href="https://designvue.benq.com.cn/2021/freeThemeWorks/imageWorkDetail?id=370&type=2&views=7"><img
              src="../../assets/img/reward/1-2.png" alt=""></a></div>
        <div><a href="https://designvue.benq.com.cn/2021/freeThemeWorks/imageWorkDetail?id=2997&type=2&views=1"><img
              src="../../assets/img/reward/1-3.png" alt=""></a></div>
      </template>
      <template v-slot:works-name2>
        <div><span>《锦心匠艺》</span><br><span>王凯硕</span></div>
        <div><span>《国潮运动会》</span><br><span>Toshe</span></div>
      </template>
      <template v-slot:rewards3>
        <div><img src="../../assets/img/reward/1.3.png" alt=""></div>
      </template>
      <template v-slot:works3>
        <div><a href="https://designvue.benq.com.cn/2021/freeThemeWorks/imageWorkDetail?id=2635&type=2&views=0"><img
              src="../../assets/img/reward/1-4.png" alt=""></a></div>
        <div><a href="https://designvue.benq.com.cn/2021/freeThemeWorks/imageWorkDetail?id=97&type=2&views=24"><img
              src="../../assets/img/reward/1-5.png" alt=""></a></div>
        <div class='notify'><img src="../../assets/img/reward/1-6.png" alt=""></div>
      </template>
      <template v-slot:works-name3>
        <div><span>《幻华跃龙绘》</span><br><span>Zsy灬幽子</span></div>
        <div><span>《美丽新中国》</span><br><span>王堃燕</span></div>
        <div><span>《长生天之韵》</span><br><span>曲阳</span></div>
      </template>
      <template v-slot:link><a href="https://www.benq.com.cn/news/434"></a></template>
    </group-wise>
    <group-wise class='even'>
      <template v-slot:group><img src="../../assets/img/reward/自由动画.png" alt="" /></template>
      <template v-slot:rewards1>
        <div><img src="../../assets/img/reward/2.1.png" alt=""></div>
      </template>
      <template v-slot:works1><a
          href="https://designvue.benq.com.cn/2021/freeThemeWorks/videoWorkDetail?id=321&type=2&views=50"><img
            src="../../assets/img/reward/2-1.png" alt=""></a></template>
      <template v-slot:works-name1><span class='rusple'>《冬日洗澡》 &nbsp;&nbsp;肖经沛（Rusple）</span></template>
      <template v-slot:rewards2>
        <div><img src="../../assets/img/reward/2.2.png" alt=""></div>
      </template>
      <template v-slot:works2>
        <div><a href="https://designvue.benq.com.cn/2021/freeThemeWorks/videoWorkDetail?id=906&type=2&views=16"><img
              src="../../assets/img/reward/2-2.png" alt=""></a></div>
        <div><a href="https://designvue.benq.com.cn/2021/freeThemeWorks/videoWorkDetail?id=3065&type=2&views=2"><img
              src="../../assets/img/reward/2-3.png" alt=""></a></div>
      </template>
      <template v-slot:works-name2>
        <div><span>《羽人升仙传》</span><br><span>刘永树</span></div>
        <div><span>《阖家》</span><br><span>33又饿了啊</span></div>
      </template>
      <template v-slot:rewards3>
        <div><img src="../../assets/img/reward/2.3.png" alt=""></div>
      </template>
      <template v-slot:works3>
        <div><a href="https://designvue.benq.com.cn/2021/freeThemeWorks/videoWorkDetail?id=1119&type=2&views=7"><img
              src="../../assets/img/reward/2-4.png" alt=""></a></div>
        <div><a href="https://designvue.benq.com.cn/2021/freeThemeWorks/videoWorkDetail?id=4&type=2&views=334"><img
              src="../../assets/img/reward/2-5.png" alt=""></a></div>
        <div><a href="https://designvue.benq.com.cn/2021/freeThemeWorks/videoWorkDetail?id=1089&type=2&views=7"><img
              src="../../assets/img/reward/2-6.png" alt=""></a></div>
      </template>
      <template v-slot:works-name3>
        <div><span>《春城细语》</span><br><span>孙雅喃/项威</span></div>
        <div><span>《超现实旅行》</span><br><span>赵鑫</span></div>
        <div><span>《宇宙飞行》</span><br><span>高展鹏</span></div>
      </template>
      <template v-slot:link><a href="https://www.benq.com.cn/news/437"></a></template>
    </group-wise>
    <group-wise :isThird="false">
      <template v-slot:group><img src="../../assets/img/reward/主题平面.png" alt="" /></template>
      <template v-slot:rewards1>
        <div><img src="../../assets/img/reward/3.1.png" alt=""></div>
      </template>
      <template v-slot:works1><a
          href="https://designvue.benq.com.cn/2021/themeWorks/imageWorkDetail?id=857&type=1&views=104"><img
            src="../../assets/img/reward/3-1.png" alt=""></a></template>
      <template v-slot:works-name1><span>《我和神兽过个年》 &nbsp;&nbsp;石积清</span></template>
      <template v-slot:rewards2>
        <div><img src="../../assets/img/reward/3.2.png" alt=""></div>
      </template>
      <template v-slot:works2>
        <div><a href="https://designvue.benq.com.cn/2021/themeWorks/imageWorkDetail?id=1423&type=1&views=23"><img
              src="../../assets/img/reward/3-2.png" alt=""></a></div>
        <div><a href="https://designvue.benq.com.cn/2021/themeWorks/imageWorkDetail?id=451&type=1&views=177"><img
              src="../../assets/img/reward/3-3.png" alt=""></a></div>
      </template>
      <template v-slot:works-name2>
        <div><span>《华夏腾飞》</span><br><span>WANWAN</span></div>
        <div><span>《大圣故游》</span><br><span>李玉</span></div>
      </template>
      <template v-slot:link><a href="https://www.benq.com.cn/news/435"></a></template>
    </group-wise>
    <group-wise :isThird="false" class='even'>
      <template v-slot:group><img src="../../assets/img/reward/主题动画.png" alt="" /></template>
      <template v-slot:rewards1>
        <div><img src="../../assets/img/reward/4.1.png" alt=""></div>
      </template>
      <template v-slot:works1><a
          href="https://designvue.benq.com.cn/2021/themeWorks/videoWorkDetail?id=1475&type=1&views=31"><img
            src="../../assets/img/reward/4-1.png" alt=""></a></template>
      <template v-slot:works-name1><span>《多彩国潮》 &nbsp;&nbsp;戴玮</span></template>
      <template v-slot:rewards2>
        <div><img src="../../assets/img/reward/4.2.png" alt=""></div>
      </template>
      <template v-slot:works2>
        <div><a href="https://designvue.benq.com.cn/2021/themeWorks/videoWorkDetail?id=2541&type=1&views=6"><img
              src="../../assets/img/reward/4-2.png" alt=""></a></div>
        <div><a href="https://designvue.benq.com.cn/2021/themeWorks/videoWorkDetail?id=1437&type=1&views=31"><img
              src="../../assets/img/reward/4-3.png" alt=""></a></div>
      </template>
      <template v-slot:works-name2>
        <div><span>《唐园记》</span><br><span>Foca-G</span></div>
        <div><span>《宝莲灯》</span><br><span>SPIKE</span></div>
      </template>
      <template v-slot:link><a href="https://www.benq.com.cn/news/438"></a></template>
    </group-wise>
  </div>
</template>

<script>
import GroupWise from './GroupWise.vue'
export default {
  name: 'PrizeContent',
  components: { GroupWise },

}
</script>

<style lang='less'>
.prize-content {
  .group {
    position: relative;

    >img {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }

  .rewards {
    display: flex;
    line-height: 26px;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 45px;
  }

  .works1 {
    line-height: 468px;
    text-align: center;
    margin: 0 auto;
    width: 888px;
    height: 468px;
    opacity: 1;

    >a {
      display: block;
      width: 882px;
      height: 468px;

      >img {
        width: 882px;
        height: 468px;
        transform: translate(-4px);
      }
    }
  }

  .works2 {
    display: flex;
    justify-content: space-around;

    >div {
      text-align: center;
      line-height: 230px;
      width: 434px;
      height: 230px;
      opacity: 1;

      >a {
        display: block;
        width: 434px;

        >img {
          width: 439px;
          transform: translateY(5px);
        }
      }
    }
  }

  .works3 {
    display: flex;
    justify-content: space-between;

    >:first-child {
      transform: translateY(-1px);
    }

    >div {
      text-align: center;
      line-height: 214px;
      width: 286px;
      height: 214px;
      opacity: 1;

      >a {
        display: block;
        width: 286px;
        height: 214px;

        >img {
          width: 286px;
          height: 214px;
          transform: translateY(5px);
        }
      }
    }

    .notify {
      >img {
        width: 286px;
        height: 214px;
        transform: translateY(5px);
      }
    }
  }

  .works-name1,
  .works-name2,
  .works-name3 {
    span {
      height: 20px;
      opacity: 1;
      font-size: 20px;
      font-family: 'TH';
      font-weight: 400;
      text-align: center;
      color: #94282e;
      letter-spacing: 0px;
    }
  }

  .works-name1 {
    text-align: center;

    >span {
      position: absolute;
      left: 50%;
      transform: translate(-65%);
    }
  }

  .works-name2 {
    position: relative;

    >div {
      height: 40px;

      >:first-child {
        font-size: 20px;
        color: #94282e;
      }

      >:last-child {
        font-size: 12px;
        color: #94282e;
        font-weight: 600;
        position: absolute;
        left: 7px;
        top: 27px;
      }
    }

    >:last-child {
      position: absolute;
      left: 50% + 1px;
      top: 0;
    }
  }

  .works-name3 {
    margin-top: 10px;
    position: relative;

    >div {
      height: 40px;

      >:first-child {
        font-size: 20px;
        color: #94282e;
      }

      >:last-child {
        font-size: 12px;
        color: #94282e;
        font-weight: 600;
        position: absolute;
        left: 7px;
        top: 27px;
      }
    }

    >:nth-child(2) {
      position: absolute;
      left: 34%;
      top: 0;
    }

    >:last-child {
      position: absolute;
      left: 68%;
      top: 0;
    }
  }

  .type {
    font-size: 8px;
    font-family: 'TH';
    font-weight: 400;
    display: flex;
    justify-content: space-between;
    padding: 0 516px 0 516px;
  }
}

.look-up {
  >div {
    >a {
      display: block;
      width: 304px;
      height: 48px;
    }
  }
}

.even {
  .look-up {
    >div {
      background-image: url('../../assets/img/reward/even.png') !important;
    }
  }

}

.rusple {
  transform: translate(-155px) !important;
}</style>